export default function getDimensionsFromImageDataUrl(
  dataURL: string
): Promise<IDimensions> {
  return new Promise<IDimensions>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.naturalHeight,
        width: img.naturalWidth,
      });
    };
    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = dataURL;
  });
}

interface IDimensions {
  height: number;
  width: number;
}
